<template lang="html">
  <div>
    <h1>Registro IVA / IRES</h1>

    <Row :gutter="30">
      <Col :span="6">
        <h2>Anno di attività:</h2>
        <Select v-model="year" @input="reload">
          <Option v-for="y in years" :key="y" :value="y">{{ y }}</Option>
        </Select>
      </Col>
      <Col :span="12">
        <h2>Mensilità IVA:</h2>
        <Select v-model="interval">
          <Option :value="3">Trimestrale</Option>
          <Option :value="6">Semestrale</Option>
        </Select>
      </Col>
      <Col :span="6">
      </Col>
    </Row>
    <br>
    <br>
    <div class="registro-iva" style="position: relative; min-height: 300px; border: 1px solid #aaa; background: #f5f5f5; box-shadow: 0 0 30px rgba(0,0,0,.1); padding: 20px;">
      <h2>Registro IVA</h2>
      <Spin size="large" fix v-if="loading"/>
      <div v-if="months">
        <Row :gutter="16" v-for="(chunk, i) in _.chunk(months, interval)" :key="i" style="break-inside: avoid;">
          <Col :span="24">
            <hr v-if="i">
            <br>
            <h2>{{ i+1 }}&deg; Periodo:</h2>
            <br>
          </Col>
          <Col :span="8" v-for="(month, month_i) in chunk.concat({commerciali:totalsInChunk(chunk)})" :key="month_i">
            <table class="my-table">
              <thead>
                <tr>
                  <th class="tetx-c" colspan="5">{{ month.date ? $d(Date.fromUTC(new Date(month.date)), 'month') : 'Totale periodo' }}</th>
                </tr>
                <tr>
                  <th class="">Conto</th>
                  <th class="text-right">Totale</th>
                  <th class="text-right">Imponib.</th>
                  <th class="text-right">IVA</th>
                  <th class="text-right">versare</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="data in month.commerciali">
                  <td class="">
                    <b>{{ data.info.ledger.code }}</b>
                    <i style="font-size: 80%; margin-left: 5px;">{{ data.info.imp }}/{{ data.info.detr }}</i>
                  </td>
                  <td class="text-right text-info">{{ (data.imp + data.tot_iva).toFixed(2) }}</td>
                  <td class="text-right">{{ data.imp.toFixed(2) }}</td>
                  <td class="text-right text-erro">{{ data.tot_iva.toFixed(2) }}</td>
                  <td class="text-right text-error">{{ data.det.toFixed(2) }}</td>
                </tr>
                <tr style="font-weight: bold">
                  <td>Totali</td>
                  <td class="text-right text-erro">{{ _.sum(_.values(month.commerciali).map(d => d.imp+d.tot_iva)).toFixed(2) }}</td>
                  <td class="text-right">{{ _.sum(_.values(month.commerciali).map(d => d.imp)).toFixed(2) }}</td>
                  <td class="text-right text-erro">{{ _.sum(_.values(month.commerciali).map(d => d.tot_iva)).toFixed(2) }}</td>
                  <td class="text-right text-erro">{{ _.sum(_.values(month.commerciali).map(d => d.det)).toFixed(2) }}</td>
                </tr>
              </tbody>
            </table>
        </Col>
      </Row>


      <!-- <pre>{{ months }}</pre> -->
    </div>
    </div>

    <br>
    <br>
      <div class="ires-box" style="break-inside: avoid; border: 1px solid #aaa; background: #f5f5f5; box-shadow: 0 0 30px rgba(0,0,0,.1); padding: 20px; max-width: 400px;">
        <h2>IRES</h2>

        <div v-if="!entrate">
          Caricamento...
        </div>
        <div v-if="entrate">
          <div style="margin: 0 0 10px">
            Entrate totali:

            <b>{{ $n(entrate.entrate, 'currency') }}</b>
          </div>

          <div style="margin: 0 0 10px">
            Entrate accessorie (imponibile):

            <b>{{ $n(-entrate.accessorie, 'currency') }}</b>
          </div>

          <div style="margin: 0 0 10px">
            Abbattimento 97%:

            <b>{{ $n(-entrate.accessorie/100*97, 'currency') }}</b>
          </div>

          <div style="margin: 0 0 10px">
            Reddito imponibile:

            <b>{{ $n(-entrate.accessorie/100*3, 'currency') }}</b>
          </div>

          <div style="margin: 0 0 10px">
            Imposta 27.5% da versare:

            <b>{{ $n(-entrate.accessorie/100*3/100*27.5, 'currency') }}</b>
          </div>

        </div>

      </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      year: (new Date).getFullYear(),
      years: null,
      months: null,
      interval: 3,
      loading: true,
      entrate: null,
    }
  },

  mounted () {
    this.reload()
    this.$http.get('contab-years?company_id=' + this.$store.company.id).then(res => {
      this.years = res.data.map(y => parseInt(y))
    })
  },

  methods: {
    reload () {
      var params = {
        year: this.year,
        company_id: this.$store.company.id,
      }
      this.loading = true
      this.$http.get('iva', { params }).then(res => {
        console.log(this.months, res.data)
        this.months = res.data
      }).finally(res => {
        this.loading = false
        console.log(this.months)
      })

      this.$http.get(`entrate-vs-accessorie/${this.$store.company.id}/${this.year}`).then(res => {
        this.entrate = res.data
      })
    },

    totalsInChunk (chunk) {
      return this._.keys(chunk[0].commerciali).map(code => { return {
        info: chunk[0].commerciali[code].info,
        imp: _.sum(chunk.map(x => x.commerciali[code].imp)),
        detr: _.sum(chunk.map(x => x.commerciali[code].detr)),
        tot_iva: _.sum(chunk.map(x => x.commerciali[code].tot_iva)),
        det: _.sum(chunk.map(x => x.commerciali[code].det)),
        }})
    }
  }
}
</script>

<style lang="scss">
  .registro-iva {
    .my-table {
      margin: 3px 0 10px;
    }
    h2 {
      margin: -10px 0;
    }
    border: 0!important;
    padding: 0!important;
    font-size: 90%;
  }
@media print {
  .ires-box, .registro-iva {
    box-shadow: none;
    background: transparent!important;
  }
}
</style>
